(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bakers-blog-post-share"] && !Shopify.designMode) return;
  try {
    // Copy link functionality
  document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('[data-copy-url]');

    copyButtons.forEach((button) => {
      const messageElement = button.querySelector('.blog-post-share__copy-message');

      let messageTimeout;

      // Copy functionality
      button.addEventListener('click', async function () {
        const url = this.dataset.copyUrl;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          // Show success message
          if (messageElement) {
            clearTimeout(messageTimeout);
            messageElement.hidden = false;
            messageTimeout = setTimeout(() => {
              messageElement.hidden = true;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy link:', err);
          // Show error feedback
          if (messageElement) {
            messageElement.textContent = 'Copy failed. Please try again.';
            messageElement.hidden = false;
            setTimeout(() => {
              messageElement.hidden = true;
            }, 3000);
          }
        }
      });

      // Hide message on Escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && messageElement && !messageElement.hidden) {
          clearTimeout(messageTimeout);
          messageElement.hidden = true;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_bakers-recipe-breadcrumb"] && !Shopify.designMode) return;
  try {
    // Copy link functionality
  document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('[data-copy-url]');

    copyButtons.forEach((button) => {
      const messageElement = button.querySelector('.recipe-share__copy-message');

      let messageTimeout;

      // Copy functionality
      button.addEventListener('click', async function () {
        const url = this.dataset.copyUrl;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          // Show success message
          if (messageElement) {
            clearTimeout(messageTimeout);
            messageElement.hidden = false;
            messageTimeout = setTimeout(() => {
              messageElement.hidden = true;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy link:', err);
          // Show error feedback
          if (messageElement) {
            messageElement.textContent = 'Copy failed. Please try again.';
            messageElement.hidden = false;
            setTimeout(() => {
              messageElement.hidden = true;
            }, 3000);
          }
        }
      });

      // Hide message on Escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && messageElement && !messageElement.hidden) {
          clearTimeout(messageTimeout);
          messageElement.hidden = true;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_bakers-recipe-header"] && !Shopify.designMode) return;
  try {
    // Clone desktop recipe share buttons to mobile version
  document.addEventListener('DOMContentLoaded', function () {
    const desktopButtons = document.querySelector('.recipe-breadcrumb-wrapper .recipe-share__buttons');
    const mobileButtons = document.querySelector('.recipe-share--mobile .recipe-share__buttons');

    if (desktopButtons && mobileButtons) {
      // Clone all buttons from desktop to mobile
      const clonedButtons = desktopButtons.cloneNode(true);
      mobileButtons.innerHTML = '';
      mobileButtons.appendChild(clonedButtons);
    }

    // Copy link functionality
    const copyButtons = document.querySelectorAll('[data-copy-url]');

    copyButtons.forEach((button) => {
      const messageElement = button.querySelector('.recipe-share__copy-message');

      let messageTimeout;

      // Copy functionality
      button.addEventListener('click', async function () {
        const url = this.dataset.copyUrl;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          // Show success message
          if (messageElement) {
            clearTimeout(messageTimeout);
            messageElement.hidden = false;
            messageElement.textContent = messageElement.textContent || 'Link copied!';
            messageTimeout = setTimeout(() => {
              messageElement.hidden = true;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy link:', err);
          // Show error feedback
          if (messageElement) {
            messageElement.textContent = 'Copy failed. Please try again.';
            messageElement.hidden = false;
            setTimeout(() => {
              messageElement.hidden = true;
            }, 3000);
          }
        }
      });
    });

    // Hide message on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && messageElement && !messageElement.hidden) {
        clearTimeout(messageTimeout);
        messageElement.hidden = true;
      }
    });
  });

  // Custom Video Controls with Player API
  document.addEventListener('DOMContentLoaded', () => {
    const videoContainer = document.querySelector('.recipe-video-embed');
    const iframe = document.getElementById('recipe-video-iframe');
    const playBtn = document.querySelector('.video-play-btn');
    const volumeBtn = document.querySelector('.video-volume-btn');

    if (!videoContainer || !iframe || !playBtn || !volumeBtn) return;

    let isPlaying = false;
    let isMuted = true; // Start muted by default
    let player = null;
    let playerType = null; // 'youtube' or 'vimeo'

    // Detect player type from iframe src
    const iframeSrc = iframe.src;
    if (iframeSrc.includes('youtube.com') || iframeSrc.includes('youtu.be')) {
      playerType = 'youtube';
    } else if (iframeSrc.includes('vimeo.com')) {
      playerType = 'vimeo';
    }

    // Initialize player based on type
    function initPlayer() {
      if (playerType === 'vimeo') {
        // Vimeo Player API
        player = {
          postMessage: (action, value) => {
            const data = { method: action };
            if (value !== undefined) {
              data.value = value;
            }
            iframe.contentWindow.postMessage(JSON.stringify(data), '*');
          },
          play: function () {
            this.postMessage('play');
          },
          pause: function () {
            this.postMessage('pause');
          },
          setVolume: function (volume) {
            this.postMessage('setVolume', volume);
          },
        };
      } else if (playerType === 'youtube') {
        // YouTube Player API via postMessage
        player = {
          postMessage: (action) => {
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: action,
              }),
              '*'
            );
          },
          play: function () {
            this.postMessage('playVideo');
          },
          pause: function () {
            this.postMessage('pauseVideo');
          },
          mute: function () {
            this.postMessage('mute');
          },
          unMute: function () {
            this.postMessage('unMute');
          },
        };
      }
    }

    // Initialize after iframe loads
    iframe.addEventListener('load', () => {
      initPlayer();
      // Mute video by default after initialization
      setTimeout(() => {
        if (player && isMuted) {
          if (playerType === 'vimeo') {
            player.setVolume(0);
          } else if (playerType === 'youtube') {
            player.mute();
          }
        }
      }, 500);
    });

    if (iframe.contentWindow) {
      initPlayer();
      // Mute video by default after initialization
      setTimeout(() => {
        if (player && isMuted) {
          if (playerType === 'vimeo') {
            player.setVolume(0);
          } else if (playerType === 'youtube') {
            player.mute();
          }
        }
      }, 500);
    }

    // Play/Pause functionality
    playBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      if (!player) {
        initPlayer();
      }

      if (!isPlaying) {
        player.play();
        isPlaying = true;
        videoContainer.classList.add('playing');
        playBtn.classList.add('playing');
        playBtn.setAttribute('aria-label', 'Pause video');

        // Hide play button after a delay
        setTimeout(() => {
          if (isPlaying && !videoContainer.matches(':hover')) {
            playBtn.style.opacity = '0';
          }
        }, 1000);
      } else {
        player.pause();
        isPlaying = false;
        videoContainer.classList.remove('playing');
        playBtn.classList.remove('playing');
        playBtn.setAttribute('aria-label', 'Play video');
        playBtn.style.opacity = '';
      }
    });

    // Volume/Mute functionality
    volumeBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      if (!player) {
        initPlayer();
      }

      isMuted = !isMuted;

      if (isMuted) {
        if (playerType === 'vimeo') {
          player.setVolume(0);
        } else if (playerType === 'youtube') {
          player.mute();
        }
        volumeBtn.classList.add('muted');
        volumeBtn.setAttribute('aria-label', 'Unmute');
        volumeBtn.querySelector('.volume-icon').setAttribute('hidden', '');
        volumeBtn.querySelector('.muted-icon').removeAttribute('hidden');
      } else {
        if (playerType === 'vimeo') {
          player.setVolume(1);
        } else if (playerType === 'youtube') {
          player.unMute();
        }
        volumeBtn.classList.remove('muted');
        volumeBtn.setAttribute('aria-label', 'Mute');
        volumeBtn.querySelector('.muted-icon').setAttribute('hidden', '');
        volumeBtn.querySelector('.volume-icon').removeAttribute('hidden');
      }
    });

    // Show play button on hover when playing
    videoContainer.addEventListener('mouseenter', () => {
      if (isPlaying) {
        playBtn.style.opacity = '';
      }
    });

    videoContainer.addEventListener('mouseleave', () => {
      if (isPlaying) {
        setTimeout(() => {
          if (isPlaying && !videoContainer.matches(':hover')) {
            playBtn.style.opacity = '0';
          }
        }, 500);
      }
    });

    // Click anywhere on video to toggle play/pause
    videoContainer.addEventListener('click', (e) => {
      // Don't trigger if clicking on buttons
      if (e.target.closest('.video-volume-btn') || e.target.closest('.video-play-btn')) return;

      // Trigger play button click
      playBtn.click();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bakers-purchase-and-delivery-ctas"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Find all purchase and delivery CTA containers
    const ctaContainers = document.querySelectorAll('.bakers-purchase-and-delivery-ctas[data-url-param]');

    ctaContainers.forEach(function (container) {
      const dataUrlParam = container.getAttribute('data-url-param');
      const storeLocatorButton = container.querySelector('.store-locator-button');

      if (dataUrlParam && storeLocatorButton) {
        // Get the current href of the store locator button
        const currentButtonUrl = storeLocatorButton.href;

        let finalUrl;

        if (currentButtonUrl.includes('?')) {
          // Button URL already has parameters, append with &
          finalUrl = currentButtonUrl + '&' + dataUrlParam;
        } else {
          // Button URL has no parameters, append with ?
          finalUrl = currentButtonUrl + '?' + dataUrlParam;
        }

        // Update the href of the store locator button
        storeLocatorButton.href = finalUrl;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cobs-nutrition-modals"] && !Shopify.designMode) return;
  try {
    // ============================================
  // MODAL MODE FUNCTIONALITY
  // ============================================
  document.addEventListener('DOMContentLoaded', function () {
    // Get all modal trigger buttons
    const modalTriggers = document.querySelectorAll('[data-modal-trigger]');

    // Add click event to each trigger
    modalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const modalId = this.getAttribute('data-modal-trigger');

        const modal = document.getElementById(modalId);
        if (modal) {
          modal.setAttribute('aria-hidden', 'false');
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';

          // Focus first focusable element
          const firstFocusable = modal.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }
      });
    });

    // Close modal functionality
    document.addEventListener('click', function (e) {
      // Close button
      if (e.target.closest('[data-modal-close]')) {
        e.preventDefault();
        const modal = e.target.closest('.cobs-modal');
        if (modal) {
          modal.setAttribute('aria-hidden', 'true');
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }
      }

      // Backdrop click
      if (e.target.classList.contains('cobs-modal__backdrop')) {
        e.preventDefault();
        const modal = e.target.closest('.cobs-modal');
        if (modal) {
          modal.setAttribute('aria-hidden', 'true');
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }
      }
    });

    // Escape key to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.cobs-modal[aria-hidden="false"]');
        if (openModal) {
          openModal.setAttribute('aria-hidden', 'true');
          openModal.style.display = 'none';
          document.body.style.overflow = '';
        }
      }
    });
  });

  // ============================================
  // COLLAPSIBLE MODE FUNCTIONALITY
  // ============================================
  class NutritionIntro extends HTMLElement {
    constructor() {
      super();
      this.controls = this.querySelector('.cobs-nutrition__controls');
      this.content = this.querySelector('.cobs-nutrition__content');
      this.toggleButtons = this.querySelectorAll('[data-toggle]');
      
      if (this.controls && this.content && this.toggleButtons.length > 0) {
        this.init();
      }
    }

    init() {
      this.toggleButtons.forEach(button => {
        button.addEventListener('click', event => this.toggle(event.currentTarget));
      });
    }

    /**
     * Expand or collapse the content and retain the initiating panel target.
     * Native button clicks already cover pointer, Enter, and Space activation.
     *
     * @param {EventTarget | null} trigger
     */
    toggle(trigger) {
      const isExpanded = !this.content.hidden;
      const panelTarget = trigger instanceof HTMLElement ? trigger.dataset.panelTarget : null;
      
      // Toggle visibility
      this.content.hidden = isExpanded;
      this.controls.dataset.state = isExpanded ? 'collapsed' : 'expanded';
      
      // Update ARIA
      this.toggleButtons.forEach(button => {
        button.setAttribute('aria-expanded', !isExpanded);
      });

      // Wait for the expanding layout to settle before measuring the requested panel.
      if (!isExpanded) {
        this.scrollToExpandedPanel(panelTarget);
      }

      // Update back button ARIA state
      const backButton = this.querySelector('.cobs-nutrition__back');
      if (backButton) {
        backButton.setAttribute('aria-expanded', !isExpanded);
      }
    }

    /**
     * Scroll the requested panel into view after the max-height transition.
     *
     * @param {string | null} panelTarget
     */
    scrollToExpandedPanel(panelTarget) {
      const target = panelTarget
        ? this.querySelector(`.cobs-nutrition__panel--${panelTarget}`)
        : this;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!(target instanceof HTMLElement)) return;

      const scroll = () => {
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'instant' : 'smooth',
          block: 'start'
        });
      };

      if (prefersReducedMotion) {
        requestAnimationFrame(scroll);
        return;
      }

      let hasScrolled = false;
      const scrollOnce = () => {
        if (hasScrolled) return;
        hasScrolled = true;
        this.content.removeEventListener('transitionend', handleTransitionEnd);
        if (this.content.hidden) return;
        scroll();
      };
      const handleTransitionEnd = event => {
        if (event.target === this.content && event.propertyName === 'max-height') {
          scrollOnce();
        }
      };

      this.content.addEventListener('transitionend', handleTransitionEnd);
      setTimeout(scrollOnce, 400);
    }
  }

  // Only define custom element if not already defined
  if (!customElements.get('nutrition-intro')) {
    customElements.define('nutrition-intro', NutritionIntro);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cobs-recipe-post-featured-product"] && !Shopify.designMode) return;
  try {
    // Promise function to wait for Swiper script to load
  function waitForSwiper() {
    return new Promise((resolve, reject) => {
      // If Swiper is already loaded, resolve immediately
      if (typeof window.Swiper !== 'undefined') {
        resolve(window.Swiper);
        return;
      }

      // Set up a timeout to prevent infinite waiting
      const timeout = setTimeout(() => {
        reject(new Error('Swiper script failed to load within timeout period'));
      }, 10000); // 10 second timeout

      // Check for Swiper availability
      const checkSwiper = () => {
        if (typeof window.Swiper !== 'undefined') {
          clearTimeout(timeout);
          resolve(window.Swiper);
        } else {
          // Check again in 100ms
          setTimeout(checkSwiper, 100);
        }
      };

      // Start checking
      checkSwiper();
    });
  }

  function initializeSwiper() {
    // Initialize Swiper for featured products using core API
    const swiperContainer = document.querySelector('.featured-products-swiper');
    const swiperSlides = document.querySelectorAll('.featured-products-swiper .swiper-slide');
    
    if (swiperContainer && swiperSlides.length > 1) {
      waitForSwiper()
        .then((Swiper) => {
          const swiper = new Swiper(swiperContainer, {
            // Core parameters
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            speed: 500,
            watchOverflow: true,
            
            // Autoplay module
            autoplay: swiperContainer.dataset.autoplay === 'true' ? {
              delay: parseInt(swiperContainer.dataset.autoplayDelay) * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            } : false,
            
            // Navigation module
            navigation: {
              nextEl: '.recipe-post-featured-product .swiper-button-next',
              prevEl: '.recipe-post-featured-product .swiper-button-prev',
            },
            
            // Pagination module
            pagination: {
              el: '.recipe-post-featured-product .swiper-pagination',
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            
            // Accessibility module
            a11y: {
              enabled: true,
              prevSlideMessage: 'Previous product',
              nextSlideMessage: 'Next product',
              firstSlideMessage: 'This is the first product',
              lastSlideMessage: 'This is the last product',
            },
            
            // Keyboard control
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            
            // Mousewheel control
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
          });

          // Store swiper instance for external access
          swiperContainer.swiper = swiper;

          const updatePaginationVisibility = () => {
            const pagination = swiperContainer.querySelector('.swiper-pagination');
            if (!pagination) return;

            pagination.hidden = swiper.snapGrid.length <= 1;
          };

          swiper.on('resize', updatePaginationVisibility);
          swiper.on('update', updatePaginationVisibility);
          updatePaginationVisibility();
        })
        .catch((error) => {
          console.error('Failed to initialize Swiper:', error);
        });
    } else if (swiperContainer && swiperSlides.length === 1) {
      // For single product, remove swiper classes and display as static content
      swiperContainer.classList.remove('swiper');
      const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (swiperWrapper) {
        swiperWrapper.classList.remove('swiper-wrapper');
        // Move slide content out of wrapper
        const slide = swiperWrapper.querySelector('.swiper-slide');
        if (slide) {
          slide.classList.remove('swiper-slide');
          swiperContainer.appendChild(slide);
          swiperWrapper.remove();
        }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initializeSwiper();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cobs-recipe-post-hero"] && !Shopify.designMode) return;
  try {
    const handleShareClick = async (event) => {
    const button = event.target.closest('[data-share]');
    if (!button) return;

    event.preventDefault();

    const url = button.dataset.share;
    const tooltip = button.nextElementSibling;

    if (!url || !tooltip) return;

    try {
      await navigator.clipboard.writeText(url);

      // Show tooltip
      tooltip.hidden = false;

      // Hide tooltip after 2 seconds
      setTimeout(() => {
        tooltip.hidden = true;
      }, 2000);
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  };

  const handleShareKeydown = (event) => {
    const button = event.target.closest('[data-share]');
    if (!button) return;

    // Check for Enter or Space key
    if (event.key === 'Enter') {
      handleShareClick(event);
    }
  };

  const handlePrintClick = (event) => {
    const button = event.target.closest('[data-print-recipe]');
    if (!button) return;

    event.preventDefault();
    window.print();
  };

  const handlePrintKeydown = (event) => {
    const button = event.target.closest('[data-print-recipe]');
    if (!button) return;

    // Check for Enter or Space key
    if (event.key === 'Enter') {
      handlePrintClick(event);
    }
  };

  document.addEventListener('click', handleShareClick);
  document.addEventListener('keydown', handleShareKeydown);
  document.addEventListener('click', handlePrintClick);
  document.addEventListener('keydown', handlePrintKeydown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-card"] && !Shopify.designMode) return;
  try {
    // Function to format duration from seconds to MM:SS
  function formatDuration(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  // Function to get Vimeo thumbnail
  async function getVimeoThumbnail(videoId, imgElement) {
    try {
      const response = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`);
      const data = await response.json();
      if (data && data[0] && data[0].thumbnail_large) {
        imgElement.src = data[0].thumbnail_large;
      }
    } catch (error) {
      console.error('Error fetching Vimeo thumbnail:', error);
    }
  }

  // Function to get Vimeo video duration
  async function getVimeoDuration(videoId, durationContainer) {
    try {
      const response = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`);
      const data = await response.json();
      if (data && data[0] && data[0].duration) {
        const durationText = durationContainer.querySelector('[data-duration-text]');
        if (durationText) {
          const formattedDuration = formatDuration(data[0].duration);
          durationText.textContent = formattedDuration;
          durationContainer.setAttribute('aria-label', `Video duration: ${formattedDuration}`);
        }
      }
    } catch (error) {
      console.error('Error fetching Vimeo duration:', error);
    }
  }

  // Function to get YouTube video duration
  async function getYouTubeDuration(videoId, durationContainer) {
    try {
      // Note: This requires YouTube Data API key in production
      // For now, we'll skip duration for YouTube videos
      const durationText = durationContainer.querySelector('[data-duration-text]');
      if (durationText) {
        durationText.textContent = '--:--';
      }
    } catch (error) {
      console.error('Error fetching YouTube duration:', error);
    }
  }

  // Function to get video duration for Shopify videos
  function updateVideoDuration(videoElement, durationContainer) {
    if (!videoElement || !durationContainer || videoElement.tagName !== 'VIDEO') return;

    const updateDuration = () => {
      if (videoElement.duration && !isNaN(videoElement.duration)) {
        const durationText = durationContainer.querySelector('[data-duration-text]');
        if (durationText) {
          const formattedDuration = formatDuration(videoElement.duration);
          durationText.textContent = formattedDuration;
          durationContainer.setAttribute('aria-label', `Video duration: ${formattedDuration}`);
        }
      }
    };

    if (videoElement.readyState >= 1) {
      updateDuration();
    } else {
      videoElement.addEventListener('loadedmetadata', updateDuration);
      if (videoElement.readyState === 0) {
        videoElement.preload = 'metadata';
        videoElement.load();
      }
    }
  }

  // Function to handle video play/pause
  function initializeVideoCard(videoCard) {
    const container = videoCard.querySelector('[data-video-container]');
    const thumbnail = videoCard.querySelector('[data-video-thumbnail]');
    const videoWrapper = videoCard.querySelector('[data-video-wrapper]');
    const playButton = videoCard.querySelector('[data-play-video]');
    const durationContainer = videoCard.querySelector('[data-duration-container]');

    if (!container || !thumbnail || !videoWrapper || !playButton) return;

    const videoType = container.getAttribute('data-video-type');
    const videoId = container.getAttribute('data-video-id');

    // Handle different video types
    if (videoType === 'internal') {
      // Original Shopify video logic
      const videoElement = videoWrapper.querySelector('video');
      if (videoElement && durationContainer) {
        updateVideoDuration(videoElement, durationContainer);
      }
    } else if (videoType === 'vimeo') {
      // Load Vimeo thumbnail if needed
      const vimeoThumbnailImg = thumbnail.querySelector('[data-vimeo-thumbnail]');
      if (vimeoThumbnailImg) {
        getVimeoThumbnail(videoId, vimeoThumbnailImg);
      }

      // Get Vimeo duration
      if (durationContainer) {
        getVimeoDuration(videoId, durationContainer);
      }
    } else if (videoType === 'youtube' && durationContainer) {
      // Get YouTube duration
      getYouTubeDuration(videoId, durationContainer);
    }

    // Play button click handler
    playButton.addEventListener('click', () => {
      thumbnail.style.display = 'none';
      videoWrapper.style.display = 'block';
      videoWrapper.setAttribute('data-playing', 'true');

      if (videoType === 'internal') {
        // Handle Shopify video
        const videoElement = videoWrapper.querySelector('video');
        if (videoElement) {
          // Ensure video is ready to play
          if (videoElement.readyState >= 2) {
            videoElement.play().then(() => {
              // Video started playing successfully
            }).catch(error => {
              // Try to play with user interaction
              videoElement.muted = true;
              videoElement.play().catch(e => {
                // Muted play also failed
              });
            });
          } else {
            // Wait for video to be ready
            videoElement.addEventListener('canplay', () => {
              videoElement.play().then(() => {
                // Video started playing after canplay event
              }).catch(error => {
                videoElement.muted = true;
                videoElement.play().catch(e => {
                  // Muted play also failed
                });
              });
            }, { once: true });
            videoElement.load();
          }
        }
      } else {
        // Handle external videos (YouTube/Vimeo)
        const iframe = videoWrapper.querySelector('iframe');
        if (iframe) {
          // Get enable_controls setting from data attribute
          const enableControls = container.getAttribute('data-enable-controls') === 'true' ? '1' : '0';

          // Always set the src for external videos, regardless of current value
          if (videoType === 'youtube') {
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=${enableControls}&showinfo=0&iv_load_policy=3&cc_load_policy=0&fs=0`;
          } else if (videoType === 'vimeo') {
            iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0&controls=${enableControls}`;
          }
        }
      }
    });
  }

  // Initialize all video cards
  function initializeVideoCards() {
    document.querySelectorAll('.video-card').forEach(initializeVideoCard);
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initializeVideoCards);

  // Handle dynamically loaded content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.querySelector) {
          node.querySelectorAll('.video-card').forEach(initializeVideoCard);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
